import React, { useState, useRef } from "react";
import { forgotPasswordAPI } from "../../model/IndexModel";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false); // ✅ NEW
  const closeButtonRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setError("Please enter a valid email address.");
      setSuccess("");
      return;
    }

    setError("");
    setSuccess("");
    setLoading(true);

    const response = await forgotPasswordAPI(email);

    setLoading(false);

    if (response?.code !== 200) {
      setError(response?.message || response?.data?.message || "");
    } else {
      setSuccess(response?.message || response?.data?.message || "");
      setEmail("");

      setTimeout(() => {
        if (closeButtonRef.current) {
          closeButtonRef.current.click();
        }
        setSuccess("");
      }, 3000);
    }
  };

  return (
    <div
      className="modal fade"
      id="forgotPasswordModal"
      tabIndex="-1"
      aria-labelledby="forgotPasswordModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="forgotPasswordModalLabel">
              Forgot Password
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButtonRef}
              onClick={() => {
                setEmail("");
                setError("");
                setSuccess("");
              }}
            ></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <label>Email *</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
              {error && (
                <p className="text-danger mt-1 text-center">{error}</p>
              )}
              {success && (
                <p className="text-success mt-1 text-center">{success}</p>
              )}
            </div>
            <div className="modal-footer border-top-0 pt-1">
              <button
                type="submit"
                className="btn btn-primary d-flex align-items-center justify-content-center"
                style={{
                  backgroundColor: "#eb2a25",
                  borderColor: "#eb2a25",
                  minWidth: "100px",
                }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
